













import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';

import SinglePickerCard from '~/components/lists/items/SinglePickerCard.vue';

@Component({
  components: { SinglePickerCard },
})
export default class SinglePicker extends Vue {
  @Prop(Array) items: () => [];
  @Prop(String) selected: '';
  @Prop(Boolean) filledChipsStyle: false;

  isClicked: boolean = false;
  idSelected: string = '';

  /* We emit the item selected so the logic is done parent-side */
  @Emit('item-selected')
  itemSelected (val: string) {
    this.idSelected = val;
    return this.idSelected;
  }

  /*
    If this.selected is defined (meaning preselected), we populate value so it
    is used in the card
  */
  @Watch('selected')
  function (val: string) {
    this.idSelected = val;
  }
}
